const data = {
  state: {
      skip: 0,
      take: 10,
      filter: {
          logic: 'and' as 'and',
          filters: []
      },
      group: []
  },
  columnsConfig: [
    {
      field: 'statut',
      title: 'Statut'
    },
    {
      field: 'numero',
      title: 'Numéro de facture'
    },
    {
      field: 'dateFacturation',
      title: 'Date de facturation'
    },
    {
      field: 'datePaiement',
      title: 'Échéance'
    },
    {
      field: 'restantDu',
      title: 'Solde restant dû (€)'
    },
    {
      field: 'docGenerated',
      title: ''
    }
  ]
};

export default data;